export const passwordMatch = (values) => {
  if (values.password !== values.passwordRepeat) {
    return {
      passwordRepeat: "validate.passwordsEquals",
    };
  }
};
